import { createStructuredSelector } from "reselect";
import {
    ACCESS_VIEW,
    ACCESS_VIEW_SUCCESS,
    ACCESS_VIEW_ERROR,
    ACCESS_VIEW_MODAL_SET,
    ACCESS_VIEW_DETAIL,
    ACCESS_VIEW_DETAIL_SUCCESS,
    ACCESS_VIEW_DETAIL_ERROR,
    ACCESS_VIEW_SEARCH_SET,
    ACCESS_VIEW_SEARCH_CHANGE

} from "../actions";

export const NAME = 'accessView';

export const AccessView = (data) => ({
    type: ACCESS_VIEW,
    payload: data
});

export const AccessViewSuccess = (data) => ({
    type: ACCESS_VIEW_SUCCESS,
    payload: data
});

export const AccessViewError = (error) => ({
    type: ACCESS_VIEW_ERROR,
    payload: error
});

export const AccessViewModalSet = (data) => ({
    type: ACCESS_VIEW_MODAL_SET,
    payload: data
});

export const AccessViewDetail = (data) => ({
    type: ACCESS_VIEW_DETAIL,
    payload: data
});

export const AccessViewDetailSuccess = (data) => ({
    type: ACCESS_VIEW_DETAIL_SUCCESS,
    payload: data
});

export const AccessViewDetailError = (error) => ({
    type: ACCESS_VIEW_DETAIL_ERROR,
    payload: error
});

export const AccessViewSearchSet = (data) => ({
    type: ACCESS_VIEW_SEARCH_SET,
    payload: data
});

export const AccessViewSearchChangeSet = (data) => ({
    type: ACCESS_VIEW_SEARCH_CHANGE,
    payload: data
});

const accessView = (state) => state[NAME];

export const AccessViewSelector = createStructuredSelector({
    accessView
})
